module.exports = __webpack_public_path__ + "static/unity_phone-6d26c073d9975a5b3c0823d15e83a444.png";